import extendTheme from "@mui/joy/styles/extendTheme";
import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";

import { paletteDark, paletteLight } from "./palettes";

const fontFamily =
  'Figtree, Inter, -apple-system, "system-ui", "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

export const joyTheme = extendTheme({
  fontFamily: {
    display: fontFamily,
    body: fontFamily,
  },
  colorSchemes: {
    light: {
      palette: { ...paletteLight },
    },
    dark: {
      palette: { ...paletteDark },
    },
  },
});

export const materialTheme = createTheme({
  typography: {
    fontFamily: fontFamily,
  },
  colorSchemes: {
    light: {
      palette: {
        ...paletteLight,
        DataGrid: {
          bg: joyTheme.colorSchemes.light.palette.background.surface,
          pinnedBg: joyTheme.colorSchemes.light.palette.background.surface,
          headerBg: joyTheme.colorSchemes.light.palette.background.surface,
        },
      },
    },
    dark: {
      palette: {
        ...paletteDark,
        DataGrid: {
          bg: joyTheme.colorSchemes.dark.palette.background.surface,
          pinnedBg: joyTheme.colorSchemes.dark.palette.background.surface,
          headerBg: joyTheme.colorSchemes.dark.palette.background.surface,
        },
      },
    },
  },
});
